var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from 'reselect';
import { GET_BILLING_INFORMATION_SUCCESS, UPDATE_BILLING_INFORMATION_SUCCESS } from './billing.action';
export var initialState = {
    billingInformation: null
};
export function billingReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_BILLING_INFORMATION_SUCCESS:
        case UPDATE_BILLING_INFORMATION_SUCCESS:
            return __assign({}, state, { billingInformation: action.payload });
        default: {
            return state;
        }
    }
}
export var getBillingInformation = function (state) { return state.billingInformation; };
export var getMainBillingSelector = function (state) { return state.billing.billingInformation; };
export var getBillingInformationSelector = createSelector(getMainBillingSelector, getBillingInformation);
